module.exports = __webpack_public_path__ + "static/media/instruction.afced212.md";